import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './EmptyInsightsCell.styles';

export interface EmptyInsightsCellProps {
  resetAll: () => void;
}

export const EmptyInsightsCell = ({ resetAll }: EmptyInsightsCellProps) => {
  const { t } = useTranslation('insights');
  return (
    <S.Container data-testid="empty-insights-cell">
      <S.Wrapper>
        <S.Img
          src="/app/static/images/empty-state/no-search-result.svg"
          alt=""
        />
        <S.Title>{t('insights:table.empty.insights.title')}</S.Title>
        <S.Description>
          {t('insights:table.empty.insights.description')}
        </S.Description>
        <S.StyledButton
          data-testid="reset-all"
          variant="empty"
          size="medium"
          label={t('insights:table.empty.insights.buttonLabel')}
          iconName="Reset"
          onClick={resetAll}
        />
      </S.Wrapper>
    </S.Container>
  );
};

EmptyInsightsCell.Styled = S;
